export default __webpack_public_path__ + "static/media/evaluate.8d31add6.svg";